import { useSessionStore } from '@/entities/session';
import { useSubscription } from '@/entities/invoice/api/useBilling';

/** Tariffs that may create and own organizations. */
export const ORG_ENABLED_TARIFFS = ['PROFESSIONAL', 'ENTERPRISE', 'UNLIMITED'];

/**
 * Organizations are a special-tariff feature. Access is granted to platform
 * admins and to users on PROFESSIONAL / ENTERPRISE plans. While the plan is
 * still loading, access is treated as disabled to avoid UI flicker.
 */
export function useOrgAccess(): { enabled: boolean; isLoading: boolean; tariff?: string } {
  const isAdmin = useSessionStore((s) => s.platformRole === 'ADMIN');
  const { data, isLoading } = useSubscription();
  const tariff = (data as { tariff?: string } | undefined)?.tariff?.toUpperCase();
  const enabled = isAdmin || (!!tariff && ORG_ENABLED_TARIFFS.includes(tariff));
  return { enabled, isLoading, tariff };
}
